import Components from '../../Components';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/resetpassword',
  exact: true,
  name: 'navigation.menu.resetpassword',
  private: false,
  type: containerTypes.PAGE,
};

export default RouteConfig;
